"use strict"

Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.FusionTablesLayer = undefined

var _defineProperty2 = require("babel-runtime/helpers/defineProperty")

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of")

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck")

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = require("babel-runtime/helpers/createClass")

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn")

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = require("babel-runtime/helpers/inherits")

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = require("react")

var _react2 = _interopRequireDefault(_react)

var _propTypes = require("prop-types")

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = require("../utils/MapChildHelper")

var _constants = require("../constants")

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.FusionTablesLayer`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#FusionTablesLayer
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var FusionTablesLayer = (exports.FusionTablesLayer = (function(
  _React$PureComponent
) {
  ;(0, _inherits3.default)(FusionTablesLayer, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#FusionTablesLayer
   */
  function FusionTablesLayer(props, context) {
    ;(0, _classCallCheck3.default)(this, FusionTablesLayer)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        FusionTablesLayer.__proto__ ||
        (0, _getPrototypeOf2.default)(FusionTablesLayer)
      ).call(this, props, context)
    )

    var fusionTablesLayer = new google.maps.FusionTablesLayer()
    ;(0, _MapChildHelper.construct)(
      FusionTablesLayer.propTypes,
      updaterMap,
      _this.props,
      fusionTablesLayer
    )
    fusionTablesLayer.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.FUSION_TABLES_LAYER,
      fusionTablesLayer
    )
    return _this
  }

  ;(0, _createClass3.default)(FusionTablesLayer, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.FUSION_TABLES_LAYER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.FUSION_TABLES_LAYER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var fusionTablesLayer = this.state[_constants.FUSION_TABLES_LAYER]
        if (fusionTablesLayer) {
          fusionTablesLayer.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },
    },
  ])
  return FusionTablesLayer
})(_react2.default.PureComponent))

FusionTablesLayer.propTypes = {
  /**
   * @type FusionTablesLayerOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type FusionTablesLayerOptions
   */
  options: _propTypes2.default.any,

  /**
   * function
   */
  onClick: _propTypes2.default.func,
}
FusionTablesLayer.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = FusionTablesLayer

var eventMap = {
  onClick: "click",
}

var updaterMap = {
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
}



//////////////////
// WEBPACK FOOTER
// ./~/react-google-maps/lib/components/FusionTablesLayer.js
// module id = 823
// module chunks = 0